<template>
  <div class="room">
      <blue-print :bridgeId="bridgeId"></blue-print>
  </div>
</template>
<script>
import BluePrint from '../../components/BluePrint'

export default {
  name: 'bridgeImg',
  components: { BluePrint },
  data() {
    return {
        bridgeId: '2003ac27-8590-4b54-9022-0a9c92e809c7'
    }
  },
}
</script>